import { createContext, ReactNode } from 'react';

interface SipClientContextProviderProps {
  children: ReactNode;
}

export const SipClientContext = createContext<SipClientContextData>(
  {} as SipClientContextData,
);

interface SipClientContextData {}

const SipClientContextProvider = ({
  children,
}: SipClientContextProviderProps) => {
  return (
    <SipClientContext.Provider value={{}}>{children}</SipClientContext.Provider>
  );
};

export default SipClientContextProvider;
